<template>
  <Portfolio msg="Welcome to Your Vue.js App"/>
</template>

<script>
import Portfolio from './components/PortfolioSection.vue';

export default {
  name: 'App',
  components: {
    Portfolio
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
